var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 6.41669H9.99556C10.8501 6.41669 11.2774 6.41669 11.5354 6.84561C11.7934 7.27454 11.6415 7.54795 11.3376 8.09488C10.7344 9.18052 9.56412 9.91669 8.21931 9.91669C7.31835 9.91669 6.49567 9.58623 5.86946 9.04169",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 6.41669V2.33335C4.66659 1.78338 4.66659 1.5084 4.49573 1.33754C4.32487 1.16669 4.04989 1.16669 3.49992 1.16669C2.94995 1.16669 2.67496 1.16669 2.5041 1.33754C2.33325 1.5084 2.33325 1.78338 2.33325 2.33335V6.41669C2.33325 6.96665 2.33325 7.24164 2.5041 7.4125C2.67496 7.58335 2.94995 7.58335 3.49992 7.58335C4.04989 7.58335 4.32487 7.58335 4.49573 7.4125C4.66659 7.24164 4.66659 6.96665 4.66659 6.41669Z",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08325 4.08331H5.83325",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 9.91665C8.74992 10.5 9.33325 12.25 10.4997 12.8333H2.33325C2.91659 12.25 3.90825 10.3833 3.20825 7.58331",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGutIcon);
export default __webpack_public_path__ + "static/media/Gut_icon.edd42f391560160702348b8b2437af6f.svg";
export { ForwardRef as ReactComponent };